// ======================================================================
// File Name       : EnterpriseTreeContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, Col, Button } from 'react-bootstrap';
import TreeViewDropdowmControl from '../../components/TreeWithDropdownControl';
import DialogConfirm from '../../components/DialogConfirm';
import { canAccessRoute } from '../../utils/AuthedUtils';
import { DORMANT_STATE, WAIT_RENDER_TIME, WRITE } from '../../constants';
import TREE_ICON from '../../images/tree/default-icon.png';
import { BULK_EXPORT, MSG_DEL_ENTERPRISE } from '../../constants/MessageTemplate';
import * as Functions from '../../constants/FunctionConstants';
import * as enterpriseActions from '../../actions/EnterpriseAction';
import { showLoading, hideLoading } from '../../utils/PageUtils';
import CustomButton from '../../components/button/CustomButton';
import * as Path from '../../constants/PathConstants';
import * as ICON from '../../constants/IconConstants';
import CustomLink from '../../components/button/CustomLink';

const initEnterpriseTree = false;

class EnterpriseTreeContainer extends Component {
  constructor() {
    super();
    this.state = {
      enterpriseCd: '',
      isDormantState: true,
      isSearchOnCondition: true,
    };
    this.searchCondition = this.searchCondition.bind(this);
    this.handleSearchBtn = this.handleSearchBtn.bind(this);
    this.handleRegister = this.handleRegister.bind(this);
    this.handleDetail = this.handleDetail.bind(this);
    this.getSearchResult = this.getSearchResult.bind(this);
    this.hideLoading = this.hideLoading.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(enterpriseActions.init());
  }

  searchCondition(filterText, node) {
    const nodeData = node.data.callbackData;
    const { enterpriseSearchForm } = this.props;
    if (!enterpriseSearchForm || !enterpriseSearchForm.values) {
      return true;
    }
    const { enterpriseName, enterpriseCd } = enterpriseSearchForm.values;
    let testResult = true;
    if (enterpriseName) {
      const cond1 = nodeData.enterpriseName.indexOf(enterpriseName) > -1;
      testResult = testResult && cond1;
    }
    if (enterpriseCd) {
      const cond2 = nodeData.enterpriseCd === enterpriseCd;
      testResult = testResult && cond2;
    }
    return testResult;
  }

  handleSearchBtn() {
    // reset search
    this.getSearchResult(false, []);
    let isSearchOnCondition = false;
    const { enterpriseSearchForm } = this.props;
    if (!this.treeInstance) {
      return;
    }
    this.props.dispatch(showLoading()).then(() => {
      const self = this;
      if (!enterpriseSearchForm || !enterpriseSearchForm.values) {
        this.setState({ isDormantState: false });
        setTimeout(() => { self.treeInstance.clearSearch(); }, WAIT_RENDER_TIME);
        return;
      }
      const { values } = enterpriseSearchForm;
      if (values.enterpriseName || values.enterpriseCd) {
        isSearchOnCondition = true;
      }
      this.setState({ isDormantState: values.dormantState }, () => {
        if (isSearchOnCondition) {
          setTimeout(() => { self.treeInstance.search(values); }, WAIT_RENDER_TIME);
        } else {
          setTimeout(() => { self.treeInstance.clearSearch(); }, WAIT_RENDER_TIME);
        }
      });
    });
  }

  handleRegister(menuData, { callbackData = {} } = {}) {
    const { dispatch } = this.props;
    const { enterpriseCd, enterpriseLayer, usageSettingInfo } = callbackData;
    const { pricePlan, pricePlanUpdateReservedFlag } = usageSettingInfo;
    const parentInfoData = {
      enterpriseCd,
      enterpriseLayer,
      pricePlan,
      pricePlanUpdateReservedFlag,
    };
    dispatch(enterpriseActions.openEnterpriseRegisterDialog(parentInfoData));
  }

  handleDetail(menuData, { callbackData = {} } = {}) {
    const { dispatch } = this.props;
    const { enterpriseCd, usageSettingInfo } = callbackData;
    const { pricePlan } = usageSettingInfo;
    dispatch(enterpriseActions.openEnterpriseDetailDialog(enterpriseCd, pricePlan));
  }

  buildMenuBtn(isOwnEnterprise) {
    const TREE_MENU = {
      [Functions.ENTERPRISE_REGISTER]: {
        icon: 'bi bi-plus-lg',
        text: '新規登録',
        onClick: this.handleRegister,
      },
      [Functions.ENTERPRISE_DETAIL]: {
        icon: 'bi bi-info-circle',
        text: '詳細',
        onClick: this.handleDetail,
      },
      [Functions.ENTERPRISE_EDIT]: {
        icon: 'bi bi-x-circle',
        text: ' 削除',
        onClick: this.props.handleDelete,
      },
    };

    return [
      Functions.ENTERPRISE_REGISTER,
      Functions.ENTERPRISE_DETAIL,
      Functions.ENTERPRISE_EDIT,
    ].reduce((acc, functionName) => {
      if (isOwnEnterprise && functionName === Functions.ENTERPRISE_EDIT) {
        return acc;
      }
      if (canAccessRoute(functionName)) {
        acc.push(TREE_MENU[functionName]);
      }
      return acc;
    }, []);
  }

  /**
   * Build tree
   */
  createTree() {
    const { bySecernId, allSecernIds, enterpriseCdLogin } = this.props;
    const isDormantState = this.state.isDormantState;
    const buildNodeData = (acc, enterpriseCd) => {
      const enterprise = bySecernId[enterpriseCd];
      if (!enterprise) return acc;
      const { child = [] } = enterprise;
      const children = child.reduce(buildNodeData, []);
      let isHidden = false;
      let className = '';
      if (enterprise.dormantState === DORMANT_STATE.INACTIVE) {
        className += 'inactive-class';
      }
      let isOwnEnterprise = false;
      if (enterprise.enterpriseCd === enterpriseCdLogin) {
        isOwnEnterprise = true;
      }
      if (!isDormantState && enterprise.dormantState === DORMANT_STATE.INACTIVE) {
        isHidden = true;
      }
      const menu = this.buildMenuBtn(isOwnEnterprise);
      acc.push({
        id: enterpriseCd,
        a_attr: { class: className },
        text: enterprise.enterpriseName,
        icon: TREE_ICON,
        data: { menu, callbackData: enterprise },
        children,
        state: { hidden: isHidden },
      });
      return acc;
    };
    return allSecernIds.reduce(buildNodeData, []);
  }

  getSearchResult(isSearchCondition, resultList) {
    if (this.props.updateSearchResult) {
      this.props.updateSearchResult(isSearchCondition, resultList);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const shouldNotUpdate =
      this.props.enterprises === nextProps.enterprises &&
      this.props.bySecernId === nextProps.bySecernId &&
      this.props.enterpriseStructure === nextProps.enterpriseStructure &&
      this.state.isDormantState === nextState.isDormantState;
    return !shouldNotUpdate;
  }

  hideLoading() {
    this.props.dispatch(hideLoading());
  }

  render() {
    // Build nodes
    const nodes = this.createTree();
    return (
      <div>
        <ActionForm
          onClickSearchBtn={this.handleSearchBtn}
          handleExportBtn={this.props.handleExportBtn}
          canEditEnterprise={this.props.canEditEnterprise}
        />
        <TreeViewDropdowmControl
          data={nodes}
          ref={(instance) => {
            this.treeInstance = instance;
          }}
          searchOnCondition={this.searchCondition}
          getSearchResult={this.getSearchResult.bind(this)}
          isSearchOnCondition={this.state.isSearchOnCondition}
          hideLoading={this.hideLoading}
        />
      </div>
    );
  }
}

EnterpriseTreeContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  bySecernId: PropTypes.shape().isRequired,
  allSecernIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { enterprises, enterpriseStructure } = state.enterprise;
  const { enterpriseSearchForm } = state.form;
  return {
    ...enterprises,
    enterpriseSearchForm,
    enterpriseCdLogin: state.authed.authedUser.enterpriseCd,
    enterpriseStructure,
  };
};

export default connect(mapStateToProps, null, null, { withRef: true })(EnterpriseTreeContainer);

const ActionForm = ({ onClickSearchBtn, handleExportBtn, canEditEnterprise }) =>
(<Form className='form-horizontal'>
  <Form.Group className="margin-top-20 text-center">
    <Col sm={12}>
      <CustomButton
        type="button"
        btnStyle="btn btn-primary btn-96"
        handleClick={onClickSearchBtn}
        text="検索"
        iconClass="bi bi-search"
      />
    </Col>
  </Form.Group>
  <Form.Group className="margin-top-20 text-center">
    <Col sm={12} className="padding-left-right-clear">
      <Col sm={9} className="inline-flex margin-bottom-15">
        {canAccessRoute(Functions.ENTERPRISE_IMPORT) && canEditEnterprise && (
          <CustomLink
            className="margin-right-7 btn-csv-import"
            to={Path.ENTERPRISE_IMPORT}
            text="CSV一括投入"
            icon={ICON.IMPORT}
          />
        )}
      </Col>
      <Col sm={3} className="margin-bottom-15">
        <CustomButton
          btnStyle="btn btn-export-csv float-end"
          handleClick={handleExportBtn}
          text="一括出力"
          iconClass="bi bi-download"
        />
      </Col>
    </Col>
  </Form.Group>
</Form>);
